var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "home-grid" }, [
      _c("div", { staticClass: "infographic" }, [
        _c("ul", { staticClass: "infographic-tabs" }, [
          _c("li", { class: { active: _vm.currentChart == "grades" } }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.currentChart = "grades"
                  }
                }
              },
              [_vm._v("Promedio semestral")]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "chart" },
          [
            _vm.currentChart == "grades"
              ? _c("grades-chart", {
                  attrs: {
                    styles: _vm.chartStyles,
                    "student-id": _vm.studentId
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.currentChart == "assistance"
              ? _c("assistance-chart", { attrs: { styles: _vm.chartStyles } })
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "main-box" }, [
        _c("div", { staticClass: "title" }, [
          _c(
            "a",
            {
              staticClass: "title-link",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.navigateTo("app.profile.alerts")
                }
              }
            },
            [
              _c("span", [
                _vm._v(
                  "Alertas (" + _vm._s(_vm.studentProfile.activeAlerts) + ")"
                )
              ]),
              _vm._v(" "),
              _c("next-arrow-icon")
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "body is-hidden-mobile" }, [
          _c(
            "h4",
            { staticClass: "is-marginless has-text-weight-medium body__title" },
            [_vm._v("FACTORES DE RIESGO")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "risk-factors" },
            _vm._l(_vm.riskFactors, function(r) {
              return _c(
                "div",
                { key: r.code, staticClass: "risk-factors-item" },
                [
                  _c("span", {
                    staticClass: "risk-factor-indicator",
                    class: { "is-at-risk": r.on }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "risk-factor-name fs-14 is-lowercase" },
                    [_vm._v(_vm._s(r.name))]
                  )
                ]
              )
            }),
            0
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "main-box" }, [
        _c(
          "a",
          {
            staticClass: "title-link",
            attrs: { href: "#" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.navigateTo("app.profile.attentions")
              }
            }
          },
          [
            _c("span", [
              _vm._v(
                "Atenciones (" +
                  _vm._s(_vm.studentProfile.attentionStats.total) +
                  ")"
              )
            ]),
            _vm._v(" "),
            _c("next-arrow-icon")
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "body is-hidden-mobile center-content" }, [
          _c("div", { staticClass: "metric-list" }, [
            _c("div", { staticClass: "metric-list-item" }, [
              _c("span", { staticClass: "metric-value" }, [
                _vm._v(_vm._s(_vm.studentProfile.attentionStats.pending))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "metric-concept" }, [
                _vm._v("Pendientes")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "metric-list-item" }, [
              _c("span", { staticClass: "metric-value" }, [
                _vm._v(_vm._s(_vm.studentProfile.attentionStats.done))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "metric-concept" }, [
                _vm._v("Realizadas")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "metric-list-item" }, [
              _c("span", { staticClass: "metric-value" }, [
                _vm._v(
                  "\n              " +
                    _vm._s(
                      _vm._f("percentage")(
                        _vm.studentProfile.attentionStats.participation
                      )
                    ) +
                    "\n            "
                )
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "metric-concept" }, [
                _vm._v("Participación")
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "main-box" }, [
        _c(
          "a",
          {
            staticClass: "title-link",
            attrs: { href: "#" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.navigateTo("app.profile.grades")
              }
            }
          },
          [_c("span", [_vm._v("Notas")]), _vm._v(" "), _c("next-arrow-icon")],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "body is-hidden-mobile center-content" }, [
          _c("div", { staticClass: "metric-list" }, [
            _c("div", { staticClass: "metric-list-item" }, [
              _c("span", { staticClass: "metric-value" }, [
                _vm._v(_vm._s(_vm.studentProfile.student.currentLevel))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "metric-concept" }, [_vm._v("Nivel")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "metric-list-item" }, [
              _c("span", { staticClass: "metric-value" }, [
                _vm._v(
                  "\n              " +
                    _vm._s(
                      _vm._f("percentage")(
                        _vm.studentProfile.student.currentCurricularProgress,
                        this.institution
                      )
                    ) +
                    "\n            "
                )
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "metric-concept" }, [
                _vm._v("Créditos")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "metric-list-item" }, [
              _c("span", { staticClass: "metric-value" }, [
                _vm._v(_vm._s(_vm._f("humanizeFloat")(_vm.average)))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "metric-concept" }, [
                _vm._v("Promedio")
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "main-box" }, [
        _c(
          "a",
          {
            staticClass: "title-link",
            attrs: { href: "#" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.navigateTo("app.profile.comments")
              }
            }
          },
          [
            _c("span", [
              _vm._v(
                "Comentarios (" + _vm._s(_vm.studentProfile.totalComments) + ")"
              )
            ]),
            _vm._v(" "),
            _c("next-arrow-icon")
          ],
          1
        ),
        _vm._v(" "),
        _vm.studentProfile.totalComments !== 0
          ? _c("div", { staticClass: "body is-hidden-mobile" }, [
              _c(
                "div",
                { staticClass: "comments-list" },
                _vm._l(_vm.studentProfile.latestComments, function(c) {
                  return _c("div", { key: c.id, staticClass: "comment-item" }, [
                    _c(
                      "div",
                      { staticClass: "comment-meta has-text-weight-semibold" },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(c.author.name) +
                            ", " +
                            _vm._s(_vm._f("humanizeDate")(c.createdAt)) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "comment-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("truncate")(
                            c.comment,
                            _vm.MAX_LENGTH_COMMENTS_RESUME
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    c.comment.length > _vm.MAX_LENGTH_COMMENTS_RESUME
                      ? _c(
                          "a",
                          {
                            staticClass: "see-more",
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.navigateTo("app.profile.comments")
                              }
                            }
                          },
                          [_vm._v("ver más")]
                        )
                      : _vm._e()
                  ])
                }),
                0
              )
            ])
          : _c("p", { staticClass: "body is-hidden-mobile center-content" }, [
              _vm._v("No hay comentarios registrados.")
            ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }